<template>
  <va-create-layout>
    <comments-form :title="title" :item="item"></comments-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
